export const EMPTY_LINE_NAME = "라인 이름 없음"
export const NOT_ASSIGNED_SCHEDULE = "미배정"
